/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as f from "react";
import { Button as T } from "@progress/kendo-react-buttons";
import { hasNode as u, toggleList as y } from "@progress/kendo-editor-common";
import { onDownPreventDefault as b } from "./utils.mjs";
import { registerForLocalization as z, provideLocalizationService as N } from "@progress/kendo-react-intl";
import { messages as S } from "../messages/index.mjs";
var L;
((h) => {
  h.createListTool = (e) => {
    const i = class extends f.Component {
      render() {
        const { view: t, render: l, ...v } = this.props;
        let s = !1;
        const g = N(this), a = e.messages.title, o = e.types, n = e.listType;
        if (t) {
          const r = t.state, m = r.schema.nodes, p = u(r, m[o.orderedList]), d = u(r, m[o.bulletList]);
          n === o.orderedList ? s = p && !d : s = !p && d;
        }
        const c = /* @__PURE__ */ f.createElement(
          T,
          {
            onClick: () => t && y(t.state, t.dispatch, t, { listType: n, ...o }, e.commandName),
            togglable: !0,
            selected: s,
            title: g.toLanguageString(a, S[a]),
            ...b,
            ...e.props,
            ...v
          }
        );
        return l ? l.call(void 0, c, { view: t }) : c;
      }
    };
    return z(i), i;
  };
})(L || (L = {}));
export {
  L as ListToolNS
};
